// Main entry point for the application
import './css/styles.css';

// Initialize the application when the DOM is ready
function initializeApp() {
  // Check if GSAP is available
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
    console.warn('GSAP or ScrollTrigger not loaded yet. Retrying...');
    setTimeout(initializeApp, 100);
    return;
  }

  // Register ScrollTrigger plugin
  gsap.registerPlugin(ScrollTrigger);
  
  console.log('SDGDR application initialized with GSAP');
  
  // Initialize any other global functionality here
  // For example, you can initialize your components that depend on GSAP
  initializeGsapComponents();
}

function initializeGsapComponents() {
  // Initialize any components that depend on GSAP
  // Example:
  // if (typeof initStickyCardsModule === 'function') {
  //   initStickyCardsModule();
  // }
}

// Start initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  // DOMContentLoaded has already fired
  initializeApp();
}

// Export any public API if needed
export {};
